<ng-container [ngSwitch]="currentPage">
  <application-settings
    *ngSwitchCase="ApplicationSettingsPage.SETTINGS"
    [settings]="settings$ | async"
    [settingsLoadingMap]="settingsLoadingMap$ | async"
    [isLoading]="isLoading$ | async"
    (onSaveMetaStructure)="saveRateCardsMetaStructure($event)"
    (onUpdateSetting)="updateApplicationSetting($event)"
    (onClearTrafficImportCache)="clearTrafficImportCache()" />

  <notification-profiles *ngSwitchCase="ApplicationSettingsPage.NOTIFICATION_PROFILES" />

  <permission-profiles *ngSwitchCase="ApplicationSettingsPage.PERMISSION_PROFILES" />
</ng-container>
